import { render, staticRenderFns } from "./submit-button.vue?vue&type=template&id=23182502"
import script from "./submit-button.vue?vue&type=script&lang=ts"
export * from "./submit-button.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports